// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__BE4ax","inner":"modal_inner__PUFG1","children":"modal_children__OtFPu"};